exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.roles-permissions-container[data-v-07b85eb6] {\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif;\n}\n.badge[data-v-07b85eb6] {\n  display: inline-block;\n  padding: 3px 8px;\n  font-size: 12px;\n  color: #fff;\n  border-radius: 10px;\n}\n", ""]);

// exports
